import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TramIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tram"}/>
}
